export const INJECT_MODAL_INSTANCE = 'modal:instance';
